import { render, staticRenderFns } from "./thome.vue?vue&type=template&id=0997992a&scoped=true"
import script from "./thome.vue?vue&type=script&lang=js"
export * from "./thome.vue?vue&type=script&lang=js"
import style0 from "./thome.vue?vue&type=style&index=0&id=0997992a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0997992a",
  null
  
)

export default component.exports